@defer (when OrderData().order_id) {
  <div class="bg-white p-3 sm:p-4 md:p-6 rounded-md shadow-md mb-4">
    <div class="flex flex-wrap items-center justify-between gap-2 sm:gap-3">
      <div class="flex-1 min-w-0">
        <p class="text-base sm:text-lg md:text-xl font-bold flex items-center gap-2">
          <i class="far fa-file-alt text-orange-500"></i>
          <span class="break-words">Orden #{{ OrderData().no_order }}</span>
        </p>
      </div>
      <div class="w-auto flex-shrink-0 text-right">
        <p
          class="text-xs sm:text-sm md:text-base font-semibold text-white px-2 sm:px-3 py-1 rounded-md inline-flex items-center gap-1 justify-center"
          [ngClass]="statusMap().get(OrderData().status) || ''"
        >
          @if (OrderData().status === 'Aprobado') { <i class="far fa-check-circle"></i> }
          @if (OrderData().status === 'Rechazado') { <i class="far fa-times-circle"></i> }
          @if (OrderData().status === 'En revisión') { <i class="far fa-question-circle"></i> }
          {{ OrderData().status }}
        </p>
      </div>
    </div>
    <div class="mt-2">
      <p class="text-sm sm:text-base md:text-lg font-bold text-gray-500 flex items-center gap-2">
        <i class="far fa-bookmark text-gray-400"></i>
        <span class="break-words">{{ OrderData().type }}</span>
      </p>
    </div>
    <div class="mt-2">
      <p class="text-sm sm:text-base md:text-lg font-bold text-gray-600 bg-gray-100 p-2 sm:p-3 rounded-md flex items-start gap-2">
        <i class="far fa-question-circle text-blue-500 mt-0.5"></i>
        <span class="break-words">Descripción: {{ OrderData().description }}</span>
      </p>
    </div>
  </div>
} @placeholder {
  <div class="bg-white p-3 sm:p-4 md:p-6 rounded-md shadow-md mb-4 animate-pulse">
    <div class="flex flex-wrap items-center justify-between gap-2 mb-2">
      <div class="flex-1 min-w-0">
        <div class="h-5 bg-gray-200 rounded w-1/3 mb-2"></div>
      </div>
      <div class="w-auto flex-shrink-0 text-right">
        <div class="h-6 bg-gray-200 rounded w-16 inline-block"></div>
      </div>
    </div>
    <div class="mt-2">
      <div class="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
    </div>
    <div class="mt-2">
      <div class="h-16 bg-gray-200 rounded w-full"></div>
    </div>
  </div>
}
